import { render, staticRenderFns } from "./FreeDrivers.vue?vue&type=template&id=7619bbe3&scoped=true&"
import script from "./FreeDrivers.vue?vue&type=script&lang=js&"
export * from "./FreeDrivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7619bbe3",
  null
  
)

export default component.exports